export const API_PATHS = {
  cartRead: "/api/v1/cart/read",
  icors: "/api/v1/icors",
  plcsInsert: "/api/v1/plcs-insert",
  salplInsert: "/api/v1/salpl-insert",
  bfslOtpSend: "/api/v1/mobileotp/send",
  bfslOtpVerify: "/api/v1/mobileotp/validate",
  bfslSaveLead: "/api/v1/savelead",
  consentRead: "/api/v1/consent-read",
  consentInsert: "/api/v1/consent-insert",
  userDetails: "/api/v1/user/details",
  federatedLogin: "/api/v1/federated-login",
  federatedAuthorize: "/api/v1/federated-authorize",
  federatedBflWebLogin: "/api/v1/federated/bflweb-login",
  federatedBflWebAuthorize: "/api/v1/federated/bflweb-authorize",
  sendOtp: "/api/v2/login-oauth-otp",
  verifyOtp: "/api/v1/login-oauth-token",
  logout: "/api/v1/logout",
  verifyToken: "/api/v1/oauth-token-verify",
  verifySsoToken: "/api/v1/login-oauth-sso-token-verify",
  generatePerpetualToken: "/api/v1/generate/perpetual-token",
  leads: "/api/v1/trading/leads",
  cityList: "/api/v1/master/bajaj-mall/city-codes",
  nearestCity: "/api/v1/nearest-city",
  cricketUpdates: "/api/v1/engagement/cricket-score",
  profInsert: "/api/v1/prof/insert",
} as const;

export type ApiPathKeys = keyof typeof API_PATHS;
